

<template>
    <div class="row item-list item-list-sm item-list-by m-b tw-p-5">
        <div class="col-xs-12">
            <h3 class="widget-title tw-pb-8 tw-pt-24" :style="$highlightColor">Order History</h3>
            <div class="loading-wrapper" v-if="loading">
                <font-awesome-icon icon="spinner-third" spin size="2x"></font-awesome-icon>
            </div>
            <div v-if="orders && !loading" class="row">
                <div class="col-md-12">
                    <template v-if="orders.length > 0">
                        <div :style="tableStyles.header" class="tw-bg-infinity-highlight-faded row header-row">
                            <div class="col col-md-3 col-sm-4 col-xs-4 col-first">
                                Order No
                            </div>
                            <div class="col col-md-3 col-sm-4 col-xs-4">
                                Date
                            </div>
                            <div class="col col-md-3 col-sm-3 col-xs-3">
                                Total
                            </div>
                            <div class="col col-md-3 col-sm-1 col-xs-1 col-last">

                            </div>
                        </div>
                        <div :style="tableStyles.body"
                            class="tw-flex tw-items-center row body-row tw-border-solid tw-border-0 tw-border-b tw-border-infinity-highlight-faded"
                            v-for="order in orders">
                            <div class="col col-md-3 col-sm-4 col-xs-4 col-first">
                                {{ order.orderNumber }}
                            </div>
                            <div class="col col-md-3 col-sm-4 col-xs-4">
                                {{ date(order.createdAt) }}
                            </div>
                            <div class="col col-md-3 col-sm-3 col-xs-3">
                                {{ order.total | displayPrice }}
                            </div>
                            <div class="col col-md-3 col-sm-1 col-xs-1 col-last text-right url-link tw-flex tw-justify-end">
                                <router-link class="tw-hidden md:tw-flex tw-items-center tw-justify-center c-button c-button--default c-button--shrinked" :to="orderDetailsUrl(order.orderNumber)">
                                    <span class="tw-hidden md:tw-inline">View full order</span><span class="tw-hidden sm:tw-inline md:tw-hidden">Details</span> <font-awesome-icon class="sm:tw-ml-3" :icon="['far', 'chevron-right']"></font-awesome-icon>
                                </router-link>
                            </div>
                        </div>
                    </template>
                    <div v-else class="row text-ceter no-orders">
                        You do not have any orders with {{ user.name }} yet.
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Configure from "../../mixins/configure";
import OrderDetails from "./order-details.vue"
export default {
    mixins: [Configure],
    components: {OrderDetails},
    created () {
        if (!this.loggedInUser) this.$router.push('/');
        this.$nextTick(() => {
            if (!this.orders) {
                this.getOrders()
            }
        })
    },
    data () {
        return {
            orders: null,
            loading: false,
            orderUrl: ab.orderUrl
        }
    },
    computed: {
        tableStyles () {
            return {
                header: { color: this.$styleConfig.menu.item_text.value },
                body: { color: this.$styleConfig.menu.item_text.value },
            }
        },
        loggedInUser () {
            if (!this.$store.state.loggedInUser) {
                this.orders = null
            }
            return this.$store.state.loggedInUser
        },
        user () {
            return this.$store.state.user
        },
    },
    methods: {
        orderDetailsUrl(orderId) {
            return { name: 'order-details', params: { orderId: orderId } }
        },
        getOrders () {
            if (this.loggedInUser) {
                this.loading = true

                this.$http.get(`${ab.apiUrl}/orders/from/${this.user.id}`, {
                    params: {
                        'api_token': this.loggedInUser.token
                    }
                }).then((response) => {
                    this.loading = false
                    this.orders = response.data.items
                }).catch(() => {
                    this.loading = false
                    this.orders = []
                })
            }
        },
        date (dateString) {
            let d = new Date(dateString)
            return d.toDateString()
        }
    }
}

</script>

<style lang="scss">
.no-orders,
.loading-wrapper {
    text-align: center;
    padding: 20px 0;
}

.order-link {
    color: #0275d8;
}

.col-last {
    padding-right: 0px !important;
}

.col-first {
    padding-left: 0px !important;
}

.header-row {
    font-size: 15px;
    padding: 13.5px 16px;
    font-weight: 600;
}

.body-row {
    font-size: 15px;
    font-weight: 400;

    padding: 13.5px 16px;
    //border-bottom: 1px solid #A7A7A7;


}

.url-link {
    color: #00D38A;
}


@media screen and (max-width: 500px) {

    .header-row {
        font-size: 12px !important;
    }

    .body-row {
        font-size: 12px !important;
    }

    .p-a-lg {
        padding: 2rem !important;
    }


    .url-link {
        font-size: 20px !important;
    }

}
</style>
